import { reduxKey } from './constants';
import { getDeviationById } from '../../redux/deviations/selectors';
export const getWriterDeviation = (state)=>getDeviationById(state, state[reduxKey] && state[reduxKey].deviationId);
export const getWriterError = (state)=>state[reduxKey] && state[reduxKey].error;
export const getIsWriterSubmitting = (state)=>state[reduxKey] && state[reduxKey].isSubmitting;
export const getIsWriterDeviationFeatured = (state)=>state[reduxKey] && state[reduxKey].isFeatured || false;
export const getIsWriterDeviationMature = (state)=>state[reduxKey] && state[reduxKey].isMature || false;
export const getIsRedirecting = (state)=>state[reduxKey] && state[reduxKey].isRedirecting || false;

//# sourceMappingURL=selectors.js.map